import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['container', 'input'];
  copyInput() {
    const container = this.containerTarget;
    this.inputTargets.forEach((input)=>{
      const targetInput = container.querySelector(input.dataset.target);
      if (targetInput) {
        if (input.dataset.copyFormat == 'ean') {
          targetInput.value = input.value.padStart(13, '0');
        } else {
          targetInput.value = input.value;
        }
        console.log('copy done')
        console.log(targetInput.value);
        targetInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    })
  }
}
